import api from '../utils/request';

class WorkplaceNewsAPI {
  async getNewsById(newsId, incrementView = true) {
    try {
      const response = await api.get(`/workplace-news/${newsId}`, {
        params: { increment_view: incrementView }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new WorkplaceNewsAPI();
